/**
 * ZM • Easify Style Labels • Auto Extract Suffix
 * 目标：
 * 1) 不再写死 5 个名字顺序
 * 2) 自动读取 Easify 原始标签
 * 3) 只显示 "/" 后面的颜色名
 * 4) 仅做视觉替换，不改真实提交值
 * 5) Easify 重渲染后自动补回
 */
(() => {
  if (window.__ZM_EASIFY_STYLE_LABELS__) return;
  window.__ZM_EASIFY_STYLE_LABELS__ = true;

  // 只处理这类图片 swatches
  const WRAP_SELECTOR = '.tpo_option-type-image-swatches-wrapper';

  // 从原始文本里提取前端要显示的名字
  function getDisplayText(rawText) {
    const text = (rawText || '').trim();
    if (!text) return '';

    // 常规格式：Black Canvas / Dusty Blue
    if (text.includes('/')) {
      const parts = text
        .split('/')
        .map(s => s.trim())
        .filter(Boolean);

      if (parts.length) return parts[parts.length - 1];
    }

    // 兜底：如果没有 /，就原样返回
    return text;
  }

  function applyOnce(root = document) {
    const wrapList = root.querySelectorAll(WRAP_SELECTOR);
    if (!wrapList.length) return;

    wrapList.forEach(wrap => {
      // 找到该区域内所有原始 label 节点
      const originalLabels = Array.from(
        wrap.querySelectorAll('span.tpo_option_label')
      );
      if (!originalLabels.length) return;

      originalLabels.forEach(orig => {
        const parent = orig.parentElement;
        if (!parent) return;

        const rawText = (orig.textContent || '').trim();
        if (!rawText) return;

        const displayText = getDisplayText(rawText);
        if (!displayText) return;

        // 已经插过就更新文字，不重复插
        let fixed = parent.querySelector(':scope > .zm-fixed-label');

        if (!fixed) {
          fixed = document.createElement('span');
          fixed.className = 'zm-fixed-label';
          parent.appendChild(fixed);
        }

        fixed.textContent = displayText;
      });
    });
  }

  // 首次运行
  applyOnce();

  // 监听 Easify 重渲染
  const obs = new MutationObserver(() => {
    clearTimeout(window.__ZM_EASIFY_STYLE_LABELS_TIMER__);
    window.__ZM_EASIFY_STYLE_LABELS_TIMER__ = setTimeout(() => {
      applyOnce();
    }, 80);
  });

  obs.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();